const INTERNAL_URL_ORIGIN = 'http://localhost';

const normalizePathname = (pathname = '') => {
  const [pathWithoutQuery] = pathname.split(/[?#]/);
  const normalizedPath = pathWithoutQuery.replace(/\/+$/, '');

  return normalizedPath || '/';
};

export const isExternalPath = (path = '') =>
  typeof path === 'string' && /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path);

// Grupo do menu sem tela propria tem duas grafias, `''` e `'#'`. Quem decide "e link?" e quem
// decide "esta ativo?" precisam responder do mesmo jeito: com `'#'` tratado como destino, o
// grupo vira link pra propria pagina e empilha o historico a cada abertura (CKTPL-1552).
export const hasOwnPage = (path) => typeof path === 'string' && !!path && path !== '#';

export const getNavigationPathname = (path = '') => {
  if (!hasOwnPage(path)) {
    return '';
  }

  if (isExternalPath(path)) {
    try {
      const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : INTERNAL_URL_ORIGIN;
      const url = new URL(path, fallbackOrigin);

      if (url.origin !== fallbackOrigin) {
        return '';
      }

      return normalizePathname(url.pathname);
    } catch (error) {
      return '';
    }
  }

  return normalizePathname(path);
};

export const isPathActive = (pathname, targetPath, deep = true) => {
  const normalizedCurrentPath = getNavigationPathname(pathname);
  const normalizedTargetPath = getNavigationPathname(targetPath);

  if (!normalizedCurrentPath || !normalizedTargetPath) {
    return false;
  }

  if (!deep) {
    return normalizedCurrentPath === normalizedTargetPath;
  }

  return (
    normalizedCurrentPath === normalizedTargetPath ||
    normalizedCurrentPath.startsWith(`${normalizedTargetPath}/`)
  );
};

export const isNavigationItemActive = (pathname, item) => {
  if (!item) {
    return false;
  }

  // `exact`: o item não acende nas páginas abaixo do path dele, quando uma delas tem item próprio.
  if (isPathActive(pathname, item.path, !item.exact)) {
    return true;
  }

  if (!Array.isArray(item.children) || item.children.length === 0) {
    return false;
  }

  return item.children.some((child) => isNavigationItemActive(pathname, child));
};
